<template>
    <div class="ph-quiz-list">
        <div class="ph-quiz-list__background">
            <img src="~@/assets/images/quiz-bgc.png" alt="kasanowa" />
        </div>
        <div class="ph-quiz-list__background-yellow kasanowa-desktop">
            <img src="~@/assets/images/yellow-elipse.png" alt="kasanowa" />
        </div>
        <KLayoutWrapper>
            <template #default>
                <div>
                    <PaginatedItemList
                        :title="$t('quiz.paginatedQuizTitle')"
                        :description="$t('quiz.paginatedQuizDescription')"
                        :span-description="$t('quiz.paginatedQuizSpanDescription')"
                        :last-page="lastPage"
                        :loading="loading"
                        :items="items"
                        btnRedirect="quiz-ph"
                        :change-page="changePageAction"
                    />
                </div>
            </template>
        </KLayoutWrapper>
    </div>
</template>

<script setup lang="ts">
import { ref } from '@vue/runtime-core';
import { toast } from 'vue3-toastify';
import QuizApi from '@/api/v1/QuizApi';
import type { IQuizResponse } from '@/models/QuizModel';
import KLayoutWrapper from '@/components/atoms/KLayoutWrapper.vue';
import PaginatedItemList from '@/components/molecules/PaginatedItemList.vue';

const page = ref<number>(1);
const itemsPerPage = ref<number>(4);
const lastPage = ref<number>(1);
const items = ref<IQuizResponse[]>([]);
const loading = ref<boolean>(false);
const quizApi = new QuizApi();
const quizList = async() => {
    loading.value = true;
    try {
        const result = await quizApi.quizList(
            page.value,
            itemsPerPage.value,
            null,
            null,
            null,
        );
        if (!result.isSuccess) {
            toast.error(t('quiz.toast.errorQuizList'));
            loading.value = false;
            return;
        }
        lastPage.value = result.payload.last_page;
        items.value = result.payload.data;
    } catch (e) {
        toast.error(t('quiz.toast.errorQuizList'));
        loading.value = false;
        return;
    }
    loading.value = false;
};
quizList();

const changePageAction = (pageValue: number) => {
    page.value = pageValue;
    quizList();
};
</script>

<style scoped lang="scss">
.ph-quiz-list {
    width: 100%;
    position: relative;

    &__background {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 0;
        width: 100%;
        height: 100%;

        img {
            object-fit: cover;
            width: 100%;
            height: calc(100% - 184px);
            min-height: calc(100vh - 184px);

            @include media-breakpoint-up(lg) {
                height: calc(100% - 217px);
                min-height: calc(100vh - 217px);
            }
        }
    }

    &__background-yellow {
        position: absolute;
        top: -30px;
        left: -40%;
        z-index: 0;
        width: 100%;
        height: max-content;

        img {
            object-fit: cover;
            width: max-content;
            height: 100vh;
        }
    }
}
</style>
